import { CONNECTION_PARAMETERS } from '../constants/systemVerificationContent'

export default function ConnectionParametersPanel() {
  return (
    <aside className="hidden text-right pointer-events-none xl:block absolute bottom-8 right-12">
      <div className="mb-4 text-[0.65rem] font-bold uppercase tracking-[0.3em] text-on-surface-variant/40">
        Connection Parameters
      </div>

      <div className="space-y-4">
        {CONNECTION_PARAMETERS.map((item) => (
          <div key={item.label} className="flex flex-col">
            <span className="text-xs text-on-surface-variant">{item.label}</span>
            <span className="font-headline text-sm font-bold text-primary">{item.value}</span>
          </div>
        ))}
      </div>
    </aside>
  )
}
